import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { ILoginFormGroup } from './ILoginFormGroup';

import { StateService } from '../../state.service';
import { RouterLinkEnum } from '../../enums/router-link-enum';
import { Subscription, filter } from 'rxjs';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
  })
export class LoginComponent implements OnInit, OnDestroy {
    
    //catch changes on sessionId
    private authenticatedSubscription: Subscription;
    public showPassword: boolean;

    public itemStyle: string = '';

    loginForm: UntypedFormGroup = new UntypedFormGroup({});

    constructor(
        private formBuilder: FormBuilder,
        private stateService: StateService,
        private router: Router
    ) { }

    ngOnInit() {
        
        //after checkLogin
        this.authenticatedSubscription = this.stateService.isAuthenticated$.pipe(filter(val => val != null)).subscribe((isAuthenticated) => {
            if (isAuthenticated)
            {
                if (this.stateService.getSessionId()) 
                {
                    this.router.navigateByUrl(RouterLinkEnum.TUNNEL_SECTIONS_DASHBOARD.link);
                }
            }            
        });

        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            rememberMe: [false]
        }) as ILoginFormGroup;
    }

    ngOnDestroy(): void {
        if (this.authenticatedSubscription) this.authenticatedSubscription.unsubscribe();
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {
        
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.stateService.checkLogin(this.f['username'].value, this.f['password'].value, this.f['rememberMe'].value);               
    }

}
